import { render, staticRenderFns } from "./history-resupply.modal.vue?vue&type=template&id=15772b98&scoped=true"
import script from "./history-resupply.modal.vue?vue&type=script&lang=js"
export * from "./history-resupply.modal.vue?vue&type=script&lang=js"
import style0 from "./history-resupply.modal.vue?vue&type=style&index=0&id=15772b98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15772b98",
  null
  
)

export default component.exports